import queryString from 'query-string';
import { generatePath } from 'react-router-dom';

import {
  API_AD_GROUP_INHAND_ITEM_URL,
  API_AD_GROUP_INHAND_URL,
  API_AD_GROUP_PRODUCT_URL,
  API_AD_GROUP_PRODUCTS_URL,
  API_ADVERTISER_PRODUCTS_URL,
} from '../../constants/apiUrls';
import { PageableList } from '../../types/contract';
import { deleteRequestJSON, getRequestJSON, postRequestJSON, putRequestJSON } from '../../util/services';

export const getAllByAdGroupId = (apiHost: string, adGroupId: number): Promise<PageableList<any>> =>
  getRequestJSON(apiHost, generatePath(API_AD_GROUP_PRODUCTS_URL, { adGroupId: adGroupId.toString() }));

// We have to loop through all the pages to get all the products by advertiser ID 
export const getAllByAdvertiserId = (apiHost: string, advertiserId: number): Promise<PageableList<any>> =>
  new Promise((resolve) => {
    const perPage = 20;

    const main = async () => {
      const getAdvertisersProducts = async (page) => {
        const queryParams = `?${queryString.stringify({
          page,
          per_page: perPage,
        })}`;

        return getRequestJSON(
          apiHost,
          generatePath(API_ADVERTISER_PRODUCTS_URL, { id: advertiserId.toString(), '*': queryParams }),
        );
      };

      const firstPage = 1;
      let data = await getAdvertisersProducts(1);

      const {
        pagination: { total_items: totalItems },
      } = data;
      const totalPages = Math.ceil(totalItems / perPage);

      const promises = [];
      for (let i = firstPage + 1; i <= totalPages; i += 1) {
        promises.push(getAdvertisersProducts(i));
      }

      const promisesResults = await Promise.all(promises);

      promisesResults.forEach((result) => {
        data = {
          ...data,
          collection: [...data.collection, ...result.collection],
        };
      });

      resolve(data);
    };

    main();
  });

export const get = (apiHost: string, adGroupId: number, productId: number): Promise<any> =>
  getRequestJSON(
    apiHost,
    generatePath(API_AD_GROUP_PRODUCT_URL, { adGroupId: adGroupId.toString(), productId: productId.toString() })
  );

export const save = (apiHost: string, adGroupId: number, payload: any): Promise<any> => {
  const {
    product: { product_id: productId },
  } = payload;
  if (productId) {
    return putRequestJSON(
      apiHost,
      generatePath(API_AD_GROUP_PRODUCT_URL, { adGroupId: adGroupId.toString(), productId }),
      payload
    );
  }
  return postRequestJSON(
    apiHost,
    generatePath(API_AD_GROUP_PRODUCTS_URL, { adGroupId: adGroupId.toString() }),
    payload
  );
};

export const attachAdGroup = (apiHost: string, adGroupId: number, payload: any): Promise<any> =>
  postRequestJSON(apiHost, generatePath(API_AD_GROUP_INHAND_URL, { adGroupId: adGroupId.toString() }), payload);

export const detachAdGroup = (apiHost: string, adGroupId: number, productId: number): Promise<any> =>
  deleteRequestJSON(apiHost, generatePath(API_AD_GROUP_INHAND_ITEM_URL, { adGroupId: adGroupId.toString(), productId: productId.toString() }));
